import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';

export const buildStepStyles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: 0,
  },
  toggleRow: {
    flexDirection: 'row',
    gap: 4,
    backgroundColor: theme.background.inset,
    borderRadius: theme.borderRadius.md,
    padding: 3,
    marginHorizontal: 16,
    marginBottom: 5,
  },
  toggleBtn: {
    flex: 1,
    minHeight: 30,
    borderRadius: theme.borderRadius.sm,
    alignItems: 'center',
    justifyContent: 'center',
  },
  toggleBtnActive: {
    backgroundColor: theme.primary,
  },
  toggleText: {
    fontSize: 12.5,
    fontWeight: '600',
    color: theme.gray[500],
  },
  toggleTextActive: {
    color: theme.onPrimary,
    fontWeight: '700',
  },
  body: {
    flex: 1,
    minHeight: 0,
  },
  footer: {
    flexShrink: 0,
    paddingHorizontal: 16,
    paddingTop: 6,
    paddingBottom: 8,
    backgroundColor: theme.background.inset,
    borderTopWidth: 1,
    borderTopColor: theme.gray[200],
  },
  reviewBtn: {
    width: '100%',
    minHeight: 44,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  reviewBtnDisabled: {
    backgroundColor: theme.background.card,
  },
  reviewBtnText: {
    fontSize: 15,
    fontWeight: '700',
    color: theme.onPrimary,
  },
  reviewBtnTextDisabled: {
    color: theme.gray[400],
  },
});
